<template>
    <div class="col-lg-12" v-if="isLoadingBlade">
        <div class="d-flex justify-content-center">
            <img :src="loadingBladeUrl" />
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import axios from 'axios';

    export default {
        data() {
            return {
                isLoadingBlade: true
            }
        },
        created() {// call logout function
            this.logout();
        },
        computed: {
        ...mapGetters(['getLogoutUserUrl', 'getUserAccessToken', 'getAuthorizationToken', 
                'loadingBladeUrl'])
        },
        methods: {
            logout() {                
                const header = {Authorization: `Bearer ${this.getAuthorizationToken}`}; 
                axios.post(this.getLogoutUserUrl, {},
                    { headers: header })// detroy server token
                    .then(() => {      
                        this.destroyAccessToken();// destroy local token                       
                    })
                    .catch(() => {
                        this.destroyAccessToken();// destroy local token 
                    })
            },
            ...mapActions(['destroyAccessToken'])
        },
    }
</script>